module.exports = __webpack_public_path__ + "3a8818e569ad5d35502c7e042337c5cb.png";